module.exports = __webpack_public_path__ + "img/Photoshop.81a46346.svg";